// Anita Week 7 / Day 4 — Команда и обязанности / Team and Responsibilities
// U.S. Grade 3 upgrade for Week 7 Day 4.

const day4 = {
  id: 'day-4',
  studentId: 'anita',
  weekId: 'week-7',
  dayId: 'day-4',
  status: 'active',
  title: 'Команда и обязанности / Team and Responsibilities',
  shortTitle: 'Команда / Team',
  theme: 'Анита учится, как команда делит обязанности. / Anita learns how a team divides responsibilities.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  courseLayers: ['reading', 'math', 'business-thinking', 'team', 'logic', 'spelling', 'creative', 'speech'],
  readingLevel: 'grade-2',
  nimnyIntro: 'Нимни собирает команду помощников. / Nimny gathers a team of helpers.',
  goals: [
    'Понять слова: команда, обязанность.',
    'Решить задачи Grade-3 с таблицами и дробями 1/2 и 1/3.',
    'Провести логику: меньше = хуже?',
    'Написать слова и объяснить родителю свою роль.'
  ],
  vocabulary: [
    { term: 'команда / team', definition: 'люди, которые работают вместе. / people who work together.' },
    { term: 'обязанность / responsibility', definition: 'дело, за которое отвечает один человек. / a task one person is responsible for.' },
    { term: 'роль / role', definition: 'какое место занимает человек в команде. / one\'s place in the team.' },
    { term: 'помощь / help', definition: 'действие для другого. / an action for another.' },
    { term: 'проверка / check', definition: 'убедиться, что всё правильно. / to make sure it is right.' },
    { term: 'вместе / together', definition: 'делать что-то в одной команде. / to work as one team.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова темы',
      prompt: 'Прочитай по-русски:\nкоманда\nобязанность\nроль\nпомощь\nпроверка\nвместе',
      ruPrimaryText: 'Прочитай 6 слов.', enHelpText: 'Read 6 words.', answer: 'Попытка чтения.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Маленькое чтение',
      prompt: 'Прочитай по-русски:\nКоманда работает вместе.\nУ каждого — своя обязанность.\nРоль помогает не путаться.\nПроверка снижает ошибки.',
      ruPrimaryText: 'Прочитай 4 фразы.', enHelpText: 'A team works together. Each has a responsibility.', answer: 'Попытка чтения.' },
    { id: 'six-people-four-tasks', type: 'text', title: 'Задание 3 — 6 человек по 4 задания',
      prompt: 'В команде 6 человек, каждый делает 4 задания.\nПотом добавили 8 задач для всех.\n\nОтветь:\n1. Сколько заданий сделали 6 человек?\n2. Сколько заданий всего после добавления 8?',
      ruPrimaryText: 'Реши по шагам (математика Grade 3).', enHelpText: 'Math: multi-step × and +.', answer: '6 × 4 = 24; 24 + 8 = 32 задания.' },
    { id: 'forty-five-tasks-hard', type: 'text', title: 'Задание 4 — 45 заданий: сложные',
      prompt: 'В команде 45 заданий.\nАнита сделала 18 сложных, друг сделал 12.\n\nОтветь:\n1. Сколько сложных заданий сделали вместе?\n2. Сколько простых заданий осталось?',
      ruPrimaryText: 'Реши по шагам.', enHelpText: 'Multi-step + and −.', answer: '18 + 12 = 30; 45 − 30 = 15 простых.' },
    { id: 'team-table', type: 'text', title: 'Задание 5 — Таблица команды',
      prompt: 'Читай таблицу заданий команды:\nАня — 9 заданий\nБоря — 12 заданий\nВера — 15 заданий\n\nОтветь:\n1. Сколько заданий сделала вся команда?\n2. У кого больше всего?\n3. На сколько Аня сделала меньше Боры?',
      ruPrimaryText: 'Читай таблицу и реши по шагам.', enHelpText: 'Table + comparison.', answer: '9 + 12 + 15 = 36; Вера; 15 − 9 = 6? Аня и Боря: 12 − 9 = 3. Клетка «Аня−Боря»: 12 − 9 = 3.' },
    { id: 'seventy-two-fractions', type: 'text', title: 'Задание 6 — 72 минуты: 1/2 и 1/3',
      prompt: 'Команда работает 72 минуты.\n1/2 — помощь дома, 1/3 — помощь в школе, остальное — отдых.\n\nОтветь:\n1. Сколько минут помощь дома?\n2. Сколько минут помощь в школе?\n3. Сколько минут отдых?',
      ruPrimaryText: 'Реши по шагам.', enHelpText: 'Fractions 1/2 and 1/3.', answer: '72 ÷ 2 = 36; 72 ÷ 3 = 24; 72 − 36 − 24 = 12 минут.' },
    { id: 'logic-less-worse', type: 'text', title: 'Задание 7 — Логика: меньше = хуже?',
      prompt: 'Если один в команде сделал меньше заданий — это всегда хуже? Почему? Ответь 1–3 предложениями.',
      ruPrimaryText: 'Логика вклада.', enHelpText: 'Logic of contribution.', answer: 'Не всегда: кто-то делает сложные, кто-то помогает другим. Важен вклад, а не только количество.' },
    { id: 'spelling-day4', type: 'text', title: 'Задание 8 — Правописание',
      prompt: 'Напиши:\nкоманда\nобязанность\nроль\nпомощь\nпроверка\n\nВставь буквы:\nком_нда\nоб_занность\nр_ль\nпом_щь\nпров_рка',
      ruPrimaryText: 'Правописание.', enHelpText: 'Spelling.', answer: 'команда, обязанность, роль, помощь, проверка.' },
    { id: 'creative-my-role', type: 'text', title: 'Задание 9 — Моя роль в команде',
      prompt: 'Опиши свою роль в команде Нимни.\nМоя роль: ______.\nМоя обязанность: ______.\nЧем помогаю другим: ______.\nКак я делаю проверку: ______.',
      ruPrimaryText: 'Творческая карточка роли.', enHelpText: 'Creative role card.', answer: 'Карточка с 4 полями.' },
    { id: 'speech-day4', type: 'text', title: 'Задание 10 — Объясни родителю',
      prompt: 'Скажи родителю по-русски:\nКоманда работает вместе.\nУ каждого — своя обязанность.\nПроверка снижает ошибки.',
      ruPrimaryText: 'Устное объяснение.', enHelpText: 'Explain to parent.', answer: 'Accept if in Russian.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши слова темы.',
    '2. Прочитай фразы.',
    '3. Реши задачи по шагам.',
    '4. Опиши свою роль в команде.',
    '5. Объясни родителю.'
  ],
  printWorksheet: {
    title: 'Команда и обязанности / Team and Responsibilities',
    subtitle: 'Неделя 7 · День 4 / Week 7 · Day 4',
    pages: [
      { title: 'Маршрут и математика / Route and Math', blocks: [
        { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
        { type: 'text', text: 'Миссия: Анита учится делить обязанности в команде.' },
        { type: 'text', text: 'Задание 1 — Слова темы:' },
        { type: 'list', items: ['команда', 'обязанность', 'роль', 'помощь', 'проверка', 'вместе'] },
        { type: 'text', text: 'Задание 2 — Маленькое чтение:' },
        { type: 'list', items: ['□ Команда работает вместе.', '□ У каждого — своя обязанность.', '□ Роль помогает не путаться.', '□ Проверка снижает ошибки.'] },
        { type: 'text', text: 'Задание 3 — 6 человек по 4 задания. Реши по шагам:' },
        { type: 'text', text: '6 человек по 4 задания; потом добавили 8.' },
        { type: 'list', items: ['6 × 4 = ______', '______ + 8 = ______'] },
        { type: 'text', text: 'Задание 4 — 45 заданий: сложные. Реши по шагам:' },
        { type: 'text', text: '45 всего; Анита 18 сложных, друг 12 сложных.' },
        { type: 'list', items: ['18 + 12 = ______', '45 − ______ = ______'] },
        { type: 'text', text: 'Задание 5 — Таблица команды. Читай таблицу и посчитай.' },
        { type: 'list', items: ['Аня — 9', 'Боря — 12', 'Вера — 15', 'Вся команда: 9 + 12 + 15 = ______', 'Больше всего: ____________________', 'Боря − Аня: 12 − 9 = ______'] },
        { type: 'text', text: 'Задание 6 — 72 минуты: 1/2 и 1/3. Реши по шагам:' },
        { type: 'text', text: '72 минуты: 1/2 — дом, 1/3 — школа, остальное — отдых.' },
        { type: 'list', items: ['72 ÷ 2 = ______ (дом)', '72 ÷ 3 = ______ (школа)', '72 − ______ − ______ = ______ (отдых)'] }
      ] },
      { title: 'Русский и защита / Russian and Defense', blocks: [
        { type: 'text', text: 'Задание 7 — Логика: меньше = хуже? Ответь 1–3 предложениями.' },
        { type: 'text', text: 'Ответ: __________________________________________________________________' },
        { type: 'text', text: 'Задание 8 — Правописание:' },
        { type: 'list', items: ['команда   обязанность   роль   помощь   проверка', 'ком_нда   об_занность   р_ль   пом_щь   пров_рка'] },
        { type: 'text', text: 'Задание 9 — Моя роль в команде (мой проект команды, карточка роли):' },
        { type: 'list', items: ['Моя роль: ____________________', 'Моя обязанность: ____________________', 'Чем помогаю другим: ____________________', 'Как делаю проверку: ____________________'] },
        { type: 'text', text: 'Задание 10 — Объясни родителю. Скажи по-русски:' },
        { type: 'list', items: ['□ Команда работает вместе.', '□ У каждого — своя обязанность.', '□ Проверка снижает ошибки.'] },
        { type: 'text', text: 'Parent Check: □ слова  □ фразы  □ math tasks  □ таблица  □ логика  □ правописание  □ роль  □ объяснение.' },
        { type: 'text', text: 'Notebook Mode fallback: если нет принтера, начерти таблицу в тетради.' }
      ] }
    ]
  },
  parentGuide: {
    goal: 'Grade-3 математика + понимание командной работы.',
    mathGoal: 'Умножение, деление, сложение, вычитание, дроби 1/2 и 1/3, чтение таблицы.',
    russianGoal: 'Прочитать 6 слов и 4 фразы, написать 5 слов.',
    readingWritingGoal: 'Карточка роли + логика вклада.',
    practicalGoal: 'Определить свою обязанность в команде.',
    whatThisLessonTeaches: 'Хорошая команда делит обязанности и делает проверку.',
    keyMessage: 'Помогать команде — это тоже вклад.',
    howToExplain: 'Скажите: «Читай таблицу построчно и считай суммы».',
    exampleDialogue: 'Parent: Сколько задач у команды?\nChild: 9 + 12 + 15 = 36.',
    readingSupport: 'Слова «обязанность» и «проверка» — по слогам.',
    russianSpeechGoal: 'Анита объясняет свою роль по формуле: роль → обязанность → польза.',
    parentTheoryCard: {
      title: 'Как объяснить команду',
      purpose: 'Показать, что каждый вклад ценен.',
      keyMessage: 'В команде все важны, если работают честно.',
      parentScript: ['«У каждого своя роль.»', '«Проверка помогает.»'],
      practiceSteps: ['Назовите роль.', 'Спросите: «Какая обязанность?»', 'Спросите: «Как ты проверяешь?»'],
      doNotSay: ['Не оценивайте детей по количеству задач.', 'Не сравнивайте с реальными коллегами взрослых.'],
      paperOnlyNotes: ['Все задания — учебная модель Нимни, не реальная команда сотрудников.']
    },
    mathAnswerKey: 'six-people-four-tasks: 6 × 4 = 24; 24 + 8 = 32. forty-five-tasks-hard: 18 + 12 = 30; 45 − 30 = 15. team-table: 9 + 12 + 15 = 36; Вера; 15 − 9 = 6 (Аня к Вере); Боря − Аня: 12 − 9 = 3. seventy-two-fractions: 72 ÷ 2 = 36; 72 ÷ 3 = 24; 72 − 36 − 24 = 12.',
    spellingAnswerKey: 'команда\nобязанность\nроль\nпомощь\nпроверка',
    answerKey: [
      { taskId: 'reading-words', answer: 'Попытка чтения слов.' },
      { taskId: 'reading-sentences', answer: 'Попытка чтения фраз.' },
      { taskId: 'six-people-four-tasks', answer: '6 × 4 = 24; 24 + 8 = 32.' },
      { taskId: 'forty-five-tasks-hard', answer: '18 + 12 = 30; 45 − 30 = 15.' },
      { taskId: 'team-table', answer: '9 + 12 + 15 = 36; Вера; 15 − 9 = 6.' },
      { taskId: 'seventy-two-fractions', answer: '72 ÷ 2 = 36; 72 ÷ 3 = 24; 72 − 36 − 24 = 12.' },
      { taskId: 'logic-less-worse', answer: 'Не всегда — важен вклад, а не только количество.' },
      { taskId: 'spelling-day4', answer: 'команда, обязанность, роль, помощь, проверка.' },
      { taskId: 'creative-my-role', answer: 'Карточка роли с 4 полями.' },
      { taskId: 'speech-day4', answer: 'Устное объяснение по-русски.' }
    ],
    check: [
      'Анита прочитала слова и фразы.',
      'Анита решила math tasks.',
      'Анита прочитала таблицу команды.',
      'Анита описала свою роль.',
      'Анита объяснила родителю.'
    ],
    spellingCheck: 'Проверить: команда, обязанность, роль, помощь, проверка.',
    readingCheck: 'Попытка русского чтения.',
    practicalCheck: 'Карточка роли содержит 4 поля.',
    drawingCriteria: 'Карточка аккуратная и понятная.',
    commonMistakes: [
      '«Меньше сделал = плохой.» Правильно: «Важен вклад и качество.»',
      '«Проверять не нужно.» Правильно: «Проверка снижает ошибки.»'
    ],
    discussionPrompts: [
      'Какая у тебя роль в семье?',
      'Что было бы, если бы никто не проверял?',
      'Как помогать не мешая?'
    ],
    ifEasy: 'Добавь 4-го участника в таблицу с числом заданий и пересчитай сумму.',
    ifDifficult: 'Оставить таблицу из 2 человек.',
    rewardGuidance: 'Базовая награда — 3 нима.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не сравнивать с реальными сотрудниками, зарплатами, отчётами. Всё — учебная команда Нимни.',
    safetyNotes: 'Не давать ребёнку связываться с реальными коллегами взрослых. Работа только с родителем.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима',
    bonuses: [
      { id: 'clear-role', label: 'Бонус за ясную роль', amount: 1 },
      { id: 'good-check', label: 'Бонус за хорошую проверку', amount: 1 }
    ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'six-people-four-tasks', 'forty-five-tasks-hard', 'team-table', 'seventy-two-fractions', 'logic-less-worse', 'spelling-day4', 'creative-my-role', 'speech-day4'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-7-day-5'
};

export default day4;
